var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable max-len */
import React from "react";
import styled from "styled-components";
import BaseSvgIcon from "./Base";
import { greys } from "../../global/colors";
var Text = styled.text(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: default;\n"], ["\n  cursor: default;\n"])));
var I = function (_a) {
    var _b = _a.color, color = _b === void 0 ? greys.mediumDark : _b, props = __rest(_a, ["color"]);
    return (React.createElement(BaseSvgIcon, __assign({ color: color }, props, { viewBox: "0 0 16 16" }),
        React.createElement("circle", { fill: "none", stroke: color, cx: "8", cy: "8", r: "7" }),
        React.createElement(Text, { id: "i", fontFamily: "Dosis-SemiBold, Dosis", fontSize: "11", fontWeight: "500", letterSpacing: "0.1721738", fill: color },
            React.createElement("tspan", { x: "7", y: "12" }, "i"))));
};
export default I;
var templateObject_1;
